import { render, staticRenderFns } from "./CircleDetails.vue?vue&type=template&id=515f2c7a&scoped=true&"
import script from "./CircleDetails.vue?vue&type=script&lang=js&"
export * from "./CircleDetails.vue?vue&type=script&lang=js&"
import style0 from "./CircleDetails.vue?vue&type=style&index=0&id=515f2c7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f2c7a",
  null
  
)

export default component.exports